import CreateNewPassword from "../../components/CreateNewPassword";
export default function AdminCreateNewPassword({ action, adminText }) {
  return (
    <>
      <CreateNewPassword adminText={adminText} action={action} />
    </>
  );
}
